import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import { InlineQuillEdit } from '../InlineQuillEdit';
import { InteractiveComponent } from '../../models/LessonComponent';
import LessonComponentService from '../../services/LessonComponentService';
import { LessonContextConsumer } from '../../models/LessonContext';
import React from 'react';
import { cloneDeep } from 'lodash';
import componentStyles from '../../styles/LessonComponents.module.css';
import { useLessonEditContext } from '../../models/LessonEditContext';
import { useTheme } from '@mui/material';

interface WithQuestionProps {
  children: JSX.Element;
  component: InteractiveComponent;
}

export default function WithQuestion(props: WithQuestionProps) {
  const { handleSettingsChange } = useLessonEditContext();

  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;

  function handleSaveQuestion(value: string) {
    const copy = cloneDeep(props.component);
    copy.content.question = value;
    handleSettingsChange(copy);
  }

  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <Box className={componentStyles.textOverflow}>
          {/* Set width to work with safari browser */}
          <FormLabel component="legend" style={{ width: '100%' }}>
            <div
              className={`question-textbox question-${props.component.componentkey}`}
              style={{ color: primaryColor }}
            >
              {mode === 'edit' ? (
                <InlineQuillEdit
                  value={props.component.content.question}
                  componentKey={props.component.componentkey}
                  styleType="noList"
                  placeholder={'Click to edit question'}
                  onChange={handleSaveQuestion}
                />
              ) : (
                <span
                  className="ql-editor"
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(
                      props.component.content.question
                    )
                  }}
                ></span>
              )}
            </div>
            {props.children}
          </FormLabel>
        </Box>
      )}
    </LessonContextConsumer>
  );
}
